import React from "react";
import "./portofolio.css";
import Button from "../../components/button/Button";
import citi from "assets/home/citi.png";

function Portoflio() {
  return (
    <div className="container-xxl">
      <div className="portofolio-works pt-5 mb-3 d-flex flex-column  flex-sm-column flex-md-row">
        <div className="portofolio-image mb-sm-5"><img src={citi} alt="citibatiment project"/></div>
        <div className="portofolio-description ">
          <div className="portofolio-work-title mt-sm-5 mt-md-1">Citibatiment - renovation enterprise site</div>
          <div className="portofolio-work-description ">
          This project is a modern, responsive website designed for a renovation company, showcasing its expertise and services. The website is structured to provide a seamless user experience while highlighting the company’s craftsmanship and professionalism. Key features include: Home page, Service page, Blog page and a Contact page.
          </div>
          <div>
            {/* <Button
              text="See more"
              onClickHandler={() => console.log("clicked ")}></Button> */}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Portoflio;
